<script lang="ts">
import { writable } from 'svelte/store';

import { Icon } from '@viamrobotics/prime-core';

import { type AuthState, AuthStatus } from '$lib/auth';
import { useFeatureFlags } from '$lib/api/feature';
import { getUserDisplayName, getUserInitials } from '$lib/user-name';

import Menu from './menu.svelte';

export let authState: AuthState;
export let login: () => unknown;
export let logout: () => unknown;

const isOpen = writable(false);
const features = useFeatureFlags();

$: userInitials =
  authState.status === AuthStatus.LoggedIn
    ? getUserInitials(authState.user)
    : '';
</script>

{#if authState.status === AuthStatus.LoggedOut}
  <div class="flex gap-3 items-center">
    <button
      on:click={login}
      class="flex h-[34px] items-center px-3 bg-light hover:bg-medium border text-xs font-medium whitespace-nowrap"
    >
      Log in
    </button>
    <button
      on:click={login}
      class="flex h-[34px] items-center px-3 bg-gray-9 hover:bg-[#333333] border border-gray-8 text-white text-xs font-medium whitespace-nowrap"
    >
      Get started for free
    </button>
  </div>
{:else if authState.status === AuthStatus.LoggedIn}
  <Menu
    {isOpen}
    label="User menu"
  >
    <svelte:fragment slot="button-text">
      {#if userInitials === ''}
        <Icon name="logout" />
      {:else}
        {userInitials}
      {/if}
    </svelte:fragment>

    <div class="border-b border-b-light p-4">
      <h2 class="text-base font-semibold text-default">
        {getUserDisplayName(authState.user)}
      </h2>
      {#if authState.user.email}
        <small class="text-sm text-subtle-2">{authState.user.email}</small>
      {/if}
    </div>
    <div class="py-2">
      {#if $features.ENABLE_USER_SETTINGS}
        <a
          href="/user/settings"
          class="flex h-10 w-full items-center gap-1.5 px-4 text-sm hover:bg-medium"
        >
          <span class="text-gray-6">
            <Icon name="cog" />
          </span>
          Settings
        </a>
      {/if}
      <button
        class="flex h-10 w-full items-center gap-1.5 px-4 text-sm hover:bg-medium"
        on:click={logout}
      >
        <span class="text-gray-6">
          <Icon name="logout" />
        </span>
        Sign out
      </button>
    </div>
  </Menu>
{/if}
